import {
    Dashboard as DashboardIcon,
    Report as ReportIcon,
    Help as HelpIcon,
    Assignment as AssignmentIcon,
    InsertDriveFile as InsertDriveFileIcon,
    ViewCarousel as ViewCarouselIcon,
    Settings as SettingsIcon,
    Notifications as NotificationsIcon,
} from '@mui/icons-material';
import { map, flatten } from "lodash";


export const main = (__) => [
    {
        key: 1,
        ico: <DashboardIcon color="inherit" />,
        name: __("menu.main.name"),
        path: "/masters",
        children: [
            {
                key: 11,
                name: __("menu.main.children.clint"),
                path: "/masters/clients",
                parent: __("menu.main.name"),
                parentPath: "/masters",
                children: []
            },
            // {
            //     key: 13,
            //     name: __("menu.main.children.contc"),
            //     path: "/masters/contacts",
            //     parent: __("menu.main.name"),
            //     parentPath: "/masters"
            // },
            {
                key: 12,
                name: __("menu.main.children.point"),
                path: "/masters/delivery_points",
                parent: __("menu.main.name"),
                parentPath: "/masters",
                children: []
            },
            {
                key: 16,
                name: __("menu.main.children.operators"),
                path: "/masters/operators",
                parent: __("menu.main.name"),
                parentPath: "/masters",
                children: []
            },
            // {
            //     key: 17,
            //     name: __("menu.main.children.zones"),
            //     path: "/masters/zones",
            //     parent: __("menu.main.name"),
            //     parentPath: "/masters",
            //     children: []
            // },
            {
                key: 18,
                name: __("menu.main.children.fuel"),
                path: "/masters/fuels",
                parent: __("menu.main.name"),
                parentPath: "/masters",
                children: []
            },
            // {
            //     key: 19,
            //     name: __("menu.main.children.invoiceRoute"),
            //     path: "/masters/invoices",
            //     parent: __("menu.main.name"),
            //     parentPath: "/masters",
            //     children: []
            // },
            {
                key: 20,
                name: __("menu.main.children.providers"),
                path: "/masters/providers",
                parent: __("menu.main.name"),
                parentPath: "/masters",
                //     children: [  // Sub-opciones para "Proveedores"
                //         // {
                //         //     key: 201,
                //         //     name: __("menu.main.children.suppliers.option1"),
                //         //     path: "/masters/suppliers/option1",
                //         //     parent: __("menu.main.children.suppliers"),
                //         //     parentPath: "/masters/suppliers"
                //         // },
                //         // {
                //         //     key: 202,
                //         //     name: __("menu.main.children.suppliers.option2"),
                //         //     path: "/masters/suppliers/option2",
                //         //     parent: __("menu.main.children.suppliers"),
                //         //     parentPath: "/masters/suppliers"
                //         // },
                //     ],
            },
            // {
            //     key: 201,
            //     name: __("menu.main.children.suppliers.children.OCBinnacle"),
            //     path: "/masters/suppliers/ocbinnacle",
            //     parent: __("menu.main.name"),
            //     parentPath: "/masters",
            //     children: []
            // },
        ],
    },
    {
        key: 2,
        ico: <ViewCarouselIcon color="inherit" />,
        name: __("menu.trade.name"),
        path: "/transactions",
        children: [
            // {
            //     key: 21,
            //     name: __("menu.trade.children.quote"),
            //     path: "/transactions/quotes",
            //     parent: __("menu.trade.name"),
            //     parentPath: "/transactions"
            // },
            // {
            //     key: 22,
            //     name: __("menu.trade.children.order"),
            //     path: "/transactions/orders",
            //     parent: __("menu.trade.name"),
            //     parentPath: "/transactions",
            //     children: []
            // },
            {
                key: 23,
                name: __("menu.trade.children.route"),
                path: "/transactions/routes",
                parent: __("menu.trade.name"),
                parentPath: "/transactions",
                children: []
            },
            {
                key: 24,
                name: __("menu.trade.children.invoice"),
                path: "/transactions/invoices",
                parent: __("menu.trade.name"),
                parentPath: "/transactions",
                children: []
            },
            {
                key: 25,
                name: __("menu.trade.children.invoiceProvider"),
                path: "/transactions/invoiceProvider",
                parent: __("menu.trade.name"),
                parentPath: "/transactions",
                children: []
            },

        ]
    },
    {
        key: 3,
        ico: <ReportIcon color="inherit" />,
        name: __("menu.report.name"),
        path: "/report",
        children: [
            {
                key: 31,
                name: __("menu.report.children.invoices"),
                path: "/report/invoices",
                parent: __("menu.report.name"),
                parentPath: "/report",
                children: []
            },
            // {
            //     key: 32,
            //     name: __("menu.report.children.orders"),
            //     path: "/report/orders",
            //     parent: __("menu.report.name"),
            //     parentPath: "/report",
            //     children: []
            // },
            {
                key: 33,
                name: __("menu.report.children.routeCost"),
                path: "/report/route-cost",
                parent: __("menu.report.name"),
                parentPath: "/report",
                children: []
            },
            // {
            //     key: 34,
            //     name: __("menu.report.children.routes"),
            //     path: "/report/routes",
            //     parent: __("menu.report.name"),
            //     parentPath: "/report",
            //     children: []
            // },
        ],
    },
    {
        key: 4,
        ico: <SettingsIcon color="inherit" />,
        name: __("menu.other.sett"),
        path: "/config",
        children: [
            {
                key: 41,
                name: __("menu.config.children.costs"),
                path: "/config/costs",
                parent: __("menu.config.name"),
                parentPath: "/config",
                children: []
            },
            {
                key: 42,
                name: __("menu.config.children.userProfile"),
                path: "/config/userProfile",
                parent: __("menu.config.name"),
                parentPath: "/config"
            },
            {
                key: 43,
                name: __("menu.config.children.logs"),
                path: "/config/logs",
                parent: __("menu.config.name"),
                parentPath: "/config"
            },
        ],
    }
]

export const others = (__) => [
    {
        key: 6,
        ico: <NotificationsIcon color="inherit" />,
        name: __("menu.other.notifications"),
        path: "/notifications",
        parent: null,
        children: []
    },
    // {
    //     key: 7,
    //     ico: <AssignmentIcon color="inherit" />,
    //     name: __("menu.other.term"),
    //     path: "/terms_and_conditions",
    //     parent: null,
    //     children: []
    // }
]

export const auth = (__) => [
    {
        key: 8,
        name: __("menu.auth.prof"),
        path: "/profile",
        parent: null,
        children: []
    },
]

export const all_options = (__) => flatten([...map(main(__), ({ children }) => children), main(__), others(__), auth(__)]);
